import React from 'react';
import { Outlet } from 'react-router-dom';
import './Layout.css';

export const Layout: React.FC = () => {
  return (
    <>
      {/* Instagram floating vector button */}
      <div className="instagram-link">
        <a href="https://www.instagram.com/schzstrg/" target="_blank" rel="noopener noreferrer">
          <img src="/Images/Vectors/instagram.svg" alt="Instagram Profile" />
        </a>
      </div>

      {/* Dynamic auto-updating copyright notice */}
      <div className="copyright-notice">
        &copy; {new Date().getFullYear()} schzstrg. All rights reserved.
      </div>

      {/* Primary routed content */}
      <Outlet />
    </>
  );
};

export default Layout;
